<template>
    <div class="footer-wrapper px-270px text-#fff bg-[url(@/assets/imgs/bg-2.png)] bg-cover bg-center bg-no-repeat">
        <div class="flex items-center justify-between pt-47px pb-26px">
            <div class="text-30px font-600">{{ title }}</div>
            <div class="flex gap-18px">
                <!-- <img src="@/assets/svgs/github.svg" @click="openLink('https://github.com/FlagOpen/FlagGems')"/> -->
                <el-tooltip effect="light" placement="top">
                    <img class="footer-img" src="@/assets/svgs/weixin-1.svg" />
                    <template #content>
                        <img class="size-180px" src="@/assets/imgs/weixin.jpg" />
                    </template>
                </el-tooltip>
                <!-- <img src="@/assets/svgs/bilibili.svg" @click="openLink('https://space.bilibili.com/3546791834290849')"/> -->
                <!-- <img src="@/assets/svgs/zhihu.svg" @click="openLink('https://www.zhihu.com/people/95-22-20-18/posts')"/> -->
                <!-- <img src="@/assets/svgs/mail.svg" @click="openLink('mailto:contact@flagos.io')"/> -->
            </div>
        </div>
        <div class="pt-30px pb-29px text-12px border-1 border-t-solid border-[rgba(255,255,255,0.2)]">
            <a class="mr-20px" href="https://beian.miit.gov.cn/" target="_blank">京ICP备19012194号-11</a>
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">京公网安备11010802045062</a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { openLink } from '@/utils/global';

const { title } = useStore('common');
</script>
<style scoped lang="scss">
.footer-img {
    width: 26px;
    height: 26px;
    cursor: pointer;
}
</style>
